import { cellTypes } from "@visiblethread/react-components/dist/components/Table/TableCell";
import TextCell from "@visiblethread/react-components/dist/components/Table/cells/TextCell";
import ButtonCell from "@visiblethread/react-components/dist/components/Table/cells/ButtonCell";
import { ReactComponent as Trash } from "icons/trash.svg";
import AddChildrenCell from "@visiblethread/react-components/dist/components/Table/cells/AddChildrenCell";
import CustomCell from "@visiblethread/react-components/dist/components/Table/cells/CustomCell";
import Regex from "layout/settings/acronymIgnoreList/cells/Regex";
import IgnoreTerm from "layout/settings/acronymIgnoreList/cells/IgnoreTerm";
import { editItem } from "slices/settings/slices/acronymIgnoreSlice";

export const tableMapper = (dispatch, editMode, addNewTerm, deleteTerm) => {
  const getHeader = () => [
    {
      text: "Ignore Terms",
      cellType: cellTypes.text,
      flexGrow: 1,
      minWidth: 500,
      autoResizable: true,
    },
    {
      text: "Regex",
      minWidth: 80,
      defaultWidth: 80,
      cellType: cellTypes.custom,
      centeredHeader: true,
    },
    { cellType: cellTypes.text, text: "", minWidth: 50, defaultWidth: 150 },
  ];

  const getEmptyRowContent = () => [
    <div className="empty_row">
      <TextCell
        text="The ignore list is empty"
        viewOnly={!editMode}
        ariaLabel="Empty list description"
      />
    </div>,
  ];

  const getTermContent = (ignoreListItem, index, error) => {
    const handleOnEditorClose = () => {
      dispatch(
        editItem({
          index,
          editedItem: { ...ignoreListItem, newlyCreated: false },
        })
      );
    };

    return [
      <CustomCell
        content={
          <IgnoreTerm
            ignoreListItem={ignoreListItem}
            editMode={editMode}
            index={index}
            error={error}
            onEditorClose={handleOnEditorClose}
          />
        }
      />,
      <CustomCell
        content={<Regex ignoreListItem={ignoreListItem} editMode={editMode} />}
      />,
      <ButtonCell
        key="button"
        content={<Trash />}
        onClick={() => {
          dispatch(deleteTerm(index));
        }}
        title="Delete Ignore Term"
      />,
    ];
  };

  const getAddNewTermContent = (index) => {
    return [
      <AddChildrenCell
        addChildrenText="Add Ignore Term"
        onClick={() => {
          dispatch(addNewTerm(index));
        }}
      />,
    ];
  };

  const getTermErrorMsg = (termToCheck, originalIndex, ignoreListItems) => {
    let errorMsg = "";
    if (ignoreListItems.length === 1 && ignoreListItems[0].term === "") {
      return errorMsg;
    }

    if (termToCheck.term.trim() === "") {
      errorMsg = "Ignore term can't be empty";
    }

    ignoreListItems.forEach((ignoreListItem, index) => {
      if (index === originalIndex) {
        // skip to avoid comparing a term with itself
        return;
      }
      if (
        ignoreListItem.term.trim().toLowerCase() ===
        termToCheck.term.trim().toLowerCase()
      ) {
        errorMsg = `The ignore term "${ignoreListItem.term}" already exists in the list. Please re-enter and try again.`;
      }
    });

    return errorMsg;
  };

  const getRows = (list) => {
    if (!list) list = [];
    if (!editMode && list.length === 0) {
      return [
        {
          content: getEmptyRowContent(),
          parentIndex: 0,
          id: 0,
        },
      ];
    }

    const result = [];
    if (list.length === 0)
      list.push({ term: "", regex: false, newlyCreated: true });
    list.forEach((ignoreListItem, index) => {
      const errorMsg = getTermErrorMsg(ignoreListItem, index, list);
      result.push({
        id: index,
        parentIndex: index,
        content: getTermContent(ignoreListItem, index, errorMsg),
        newlyCreated: ignoreListItem.newlyCreated,
      });
    });

    if (editMode) {
      result.push({
        content: getAddNewTermContent(result.length - 1),
        childrenOf: result.length - 1,
        id: result.length,
      });
    }

    return result;
  };

  const getState = (tableRows) => {
    const result = [];
    tableRows.forEach((row) => {
      if (row.parentIndex !== undefined) {
        result.push({
          term: row.content[0].props.content.props.ignoreListItem.term,
          regex: row.content[1].props.content.props.ignoreListItem.regex,
          newlyCreated: false,
        });
      }
    });
    return result;
  };

  return { getHeader, getRows, getState };
};
